export enum recruitmentsCompanyTypes {
  FETCH_RECRUIMENTS_COMPANY_REQUEST = "FETCH_RECRUIMENTS_COMPANY_REQUEST",
  FETCH_RECRUIMENTS_COMPANY_SUCCESS = "FETCH_RECRUIMENTS_COMPANY_SUCCESS",
  FETCH_RECRUIMENTS_COMPANY_FAILURE = "FETCH_RECRUIMENTS_COMPANY_FAILURE",
}